import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import { getBottomMargin, getZIndex } from 'reactApp/modules/snackbar/snackbar.selectors';

import { SnackbarComponent } from './components/SnackbarComponent';
import { useSnackbarsList } from './hooks/useSnackbarsList';
import styles from './Snackbars.css';

export const Snackbars = memo(function Snackbars() {
    const snackbarsList = useSnackbarsList();
    const bottomMargin = useSelector(getBottomMargin);
    const zIndex = useSelector(getZIndex);

    if (!snackbarsList) {
        return null;
    }

    const style: React.CSSProperties = {};
    if (bottomMargin) {
        style.bottom = `${bottomMargin}px`;
    }
    if (zIndex !== undefined) {
        style.zIndex = zIndex;
    }

    return (
        <div className={styles.root} style={Object.keys(style).length ? style : undefined}>
            {snackbarsList.map((item) => (
                <div className={styles.snackbar} key={item.id} data-qa-id={item.type}>
                    <SnackbarComponent {...item} />
                </div>
            ))}
        </div>
    );
});
